import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../AppContext';
import decline from '../../../image/decline.png';
import onhold from '../../../image/onhold.png';
import { GetStatus} from '../../../services/OnbordingService';

const ApplicationStatus = () => {
    const [saveStatusId, setSaveStatusId] = useState();
    const location = useLocation();
    const email = location?.state?.email;
    const navigate = useNavigate();
    const { responseMessage } = useContext(AppContext);

    const handleClickAppStatus = () => {
        navigate('/checkApplicationStatus');
    };

    const getStatusIdCall = async () => {
        try {
            const response = await GetStatus(email);
            setSaveStatusId(response?.data);
        } catch (error) {
            console.error('Error fetching notes list:', error);
        }
    };

    useEffect(() => {
        getStatusIdCall();
    }, []);

    const getActiveClass = (status_id) => {
        const currentStatusId = parseInt(saveStatusId?.status_id, 10);
        if (currentStatusId === 4) {
            return status_id === 1 || status_id === 2 ? 'active' : '';
        } else if (currentStatusId === 5) {
            return status_id === 1 || status_id === 2 || status_id === 3 ? 'active' : '';
        } else if (currentStatusId === 6 || currentStatusId === 7) {
            return status_id === 1 ? 'active' : '';
        } else {
            return status_id === 1 ? 'active' : '';
        }
    };

    const getFieldsetVisibility = () => {
        const currentStatusId = parseInt(saveStatusId?.status_id, 10);
        switch (currentStatusId) {
            case 4:
                return 'apprvProgs';
            case 5:
                return 'compltProgs';
            case 6:
                return 'deniedProgs';
            case 7:
                return 'onHoldProgs';
            default:
                return 'submProgs';
        }
    };

    const activeFieldset = getFieldsetVisibility();

    // (parseInt(saveStatusId?.status_id, 10) === 6 || parseInt(saveStatusId?.status_id, 10) === 7) ? 'wid49' : ''

    return (
        <div>
            <div className="bg-image d-flex justify-content-center align-items-center bannerAppStatus"></div>

            {/* Content */}
            <section className="newApp">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h3 className="marB10">T-Mobile Sub-Dealer Application Status</h3>
                        </div>
                    </div>

                    {/* MultiStep Form */}
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <form id="msform">
                                {/* Progress Bar */}
                                <ul id="progressbar">
                                <li className={`${getActiveClass(1)} ${parseInt(saveStatusId?.status_id, 10) === 6 ? 'wid49' : ''}`}>
                                        <span>1</span>Submitted to T-Mobile
                                    </li>
                                    {parseInt(saveStatusId?.status_id, 10) === 6 ? (
                                        <li className="decline wid49">
                                            <img src={decline} alt="Decline" />
                                            Denied
                                        </li>
                                    ) : parseInt(saveStatusId?.status_id, 10) === 7 ? (
                                        <li className="onhold">
                                            <img src={onhold} alt="onhold" />
                                            On Hold
                                        </li>
                                    ) : (
                                        <li className={getActiveClass(2)}>
                                            <span>2</span>Approved
                                        </li>
                                    )}

                                    {parseInt(saveStatusId?.status_id, 10) !== 6  && (
                                        <li className={getActiveClass(3)}>
                                            <span>3</span>Onboard Completed
                                        </li>
                                    )}
                                </ul>

                                {/* Fieldsets */}
                                <fieldset className={`submProgs ${activeFieldset === 'submProgs' ? 'visible' : 'hidden'}`}>
                                    <p>Your application has been submitted to T-Mobile for review.</p>
                                </fieldset>
                                <fieldset className={`apprvProgs ${activeFieldset === 'apprvProgs' ? 'visible' : 'hidden'}`}>
                                    <p>
                                        Your application has been approved by T-Mobile. Please sign the onboarding documents sent to
                                        your provided email address via DocuSign to complete the onboarding process.
                                    </p>
                                </fieldset>
                                <fieldset className={`compltProgs ${activeFieldset === 'compltProgs' ? 'visible' : 'hidden'}`}>
                                    <p>
                                        You have successfully completed your onboarding process. Thank you for your continued partnership
                                        and trust! We look forward to continuing to grow your business!
                                    </p>
                                </fieldset>
                                <fieldset className={`deniedProgs ${activeFieldset === 'deniedProgs' ? 'visible' : 'hidden'}`}>
                                    <p>Unfortunately, T-Mobile has decided not to proceed with your application this time!</p>
                                </fieldset>
                                <fieldset className={`onHoldProgs ${activeFieldset === 'onHoldProgs' ? 'visible' : 'hidden'}`}>
                                    <p>
                                        Your business is currently coded with another Primary Agent. Please follow the steps which we sent you at{' '}
                                        <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                                            {saveStatusId?.email}
                                        </a>{' '}
                                        to obtain the release from your current Primary Agent and to move your business under Cellhub.
                                    </p>

                                </fieldset>
                            </form>
                        </div>
                    </div>

                    <p className='hiddenTab'>&nbsp;</p>

                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="marB10">Need Help?</h3>
                            <p className="pHeading">
                                If you have any questions or concerns about this program or process, email us at:{' '}
                                <a href="mailto:dandhsupport@cellhub.com" target="_blank" rel="noopener noreferrer">
                                    dandhsupport@cellhub.com
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ApplicationStatus;
